import { Checkbox, DateInput, Dropdown, Field, NumericInput, TextOutput, TimeInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { hasNonEmptyValue, valueOrDefault } from 'Lib/Any';
import { DateTimeDataFormat } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { uniqBy } from 'ramda';
import { useSelector } from 'react-redux';

let BsCompactionDataSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const preventRemove = useSelector(pipe(createWorksheetSelector!('TestPortions'), (p) => p.length <= 5));

  const enterConvertedWetDensity = useSelector(
    pipe(createWorksheetSelector!('Preparation.EnterConvertedWetDensity'), valueOrDefault(false))
  );

  const mouldOptions = useSelector(
    pipe(createWorksheetSelector!('Equipment.Moulds.Moulds'), (moulds) =>
      uniqBy(
        (mould: any) => mould.Mould.Id,
        moulds.filter((mould: any) => hasNonEmptyValue(mould.Mould))
      ).map((mould: any) => ({
        label: mould.Mould.Code,
        value: mould.MddMouldId,
      }))
    ),
    deepEquals
  );

  const mouldsHidden = useSelector(
    pipe(createWorksheetSelector!('Equipment.Moulds.Moulds'), (moulds) => moulds.length === 1)
  );

  return (
    <WorksheetGridFieldSection name="TestPortions">
      <WorksheetRecordGrid
        name="TestPortions"
        orientation="horizontal"
        scrollLinkId="mddCompaction"
        rowHeaderWidth={200}
        recordProps={{
          width: 130,
          heading: 'number',
          headingLabel: 'Test Portion ID',
          preventRemove: preventRemove,
        }}
        fieldSet={[
          {
            name: 'MddMouldId',
            component: <Field input={<Dropdown />} options={mouldOptions} simpleValue />,
            hidden: mouldsHidden,
          },
          { name: 'PortionMass', component: <Field input={<NumericInput />} />, hidden: !enterConvertedWetDensity },
          {
            name: 'WaterAddedTargetPercent',
            component: <Field input={<NumericInput />} />,
            hidden: !enterConvertedWetDensity,
          },
          { name: 'WaterAddedTarget', component: <Field input={<TextOutput />} />, hidden: !enterConvertedWetDensity },
          {
            name: 'PortionMassAfterWaterAdded',
            component: <Field input={<NumericInput />} />,
            hidden: !enterConvertedWetDensity,
          },
          { name: 'WaterAdded', component: <Field input={<TextOutput />} />, hidden: !enterConvertedWetDensity },
          { name: 'WaterAddedPercent', component: <Field input={<TextOutput />} />, hidden: !enterConvertedWetDensity },
          {
            name: 'Curing.StartedAtDateTime',
            component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
            label: 'Soak Start Date',
          },
          {
            name: 'Curing.StartedAtDateTime',
            component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
            label: 'Soak Start Time',
          },
          {
            name: 'Curing.CompletedAtDateTime',
            component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
            label: 'Soak Finish Date',
          },
          {
            name: 'Curing.CompletedAtDateTime',
            component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
            label: 'Soak Finish Time',
          },
          {
            name: 'Curing.Duration',
            component: <Field input={<TextOutput />} />,
          },
          { name: 'SoilHeightLimitChecked', component: <Field input={<Checkbox />} /> },
          { name: 'WetSoilAndMouldMass', component: <Field input={<NumericInput />} /> },
          { name: 'WetSoilMass', component: <Field input={<TextOutput />} /> },
          { name: 'WetDensity', component: <Field input={<TextOutput />} /> },
        ]}
      ></WorksheetRecordGrid>
    </WorksheetGridFieldSection>
  );
};

BsCompactionDataSection = withInjectedProps(BsCompactionDataSection);

export { BsCompactionDataSection };
export default BsCompactionDataSection;
